import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import images from '../../assets';
import './ServiceDetailsCard.scss';

function ServiceDetailsCard(props) {
    const { service, index = 0 } = props;
    const [isOpen, setOpen] = useState(false);
    const isEven = index % 2 === 0;
    
    return (
        <div className={`service-detail-card ${isEven ? 'service-card-left' : 'service-card-right'}`}>
            <div className="service-card-number">
                <span>{String(index + 1).padStart(2, '0')}</span>
            </div>
            
            <div className="service-content-wrapper">
                <div className="service-header">
                    <h3 className="service-title">{service?.name}</h3>
                </div>

                <div className="service-content-container">
                    <div className={`service-detail-top ${isEven ? 'layout-left' : 'layout-right'}`}>
                        <div className="service-details">
                            <div
                                className={
                                    !isOpen ? 'trimmed-text' : 'untrimmed-text'
                                }
                            >
                                {service?.desc}
                            </div>
                        </div>
                        <div
                            className="service-img"
                            style={{
                                backgroundImage: `url(${images[service?.img]})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}
                        >
                            <div className="service-img-overlay"></div>
                        </div>
                    </div>

                    {service?.points?.length && (
                        <Collapse isOpened={isOpen} className={'service-collapse'}>
                            <div className="collapse-wrapper">
                                <h3 className="service-subtitle">
                                    <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="20" 
                                        height="20" 
                                        viewBox="0 0 24 24" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        strokeWidth="2"
                                    >
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                    </svg>
                                    What We Provide
                                </h3>
                                <div className="collapse-content">
                                    {service?.points?.map((point, pointIndex) => (
                                        <div className="collapse-point" key={pointIndex}>
                                            <svg 
                                                xmlns="http://www.w3.org/2000/svg" 
                                                width="16" 
                                                height="16" 
                                                viewBox="0 0 24 24" 
                                                fill="none" 
                                                stroke="currentColor" 
                                                strokeWidth="2"
                                            >
                                                <polyline points="20 6 9 17 4 12"></polyline>
                                            </svg>
                                            <span>{point}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Collapse>
                    )}

                    <div
                        className="service-detail-btn"
                        onClick={() => setOpen((isOpen) => !isOpen)}
                    >
                        <span className="btn-text">
                            {isOpen ? 'Show Less' : 'Learn More'}
                        </span>
                        <div className="btn-icon-wrapper">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="16"
                                height="16"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className={isOpen ? 'icon-rotated' : ''}
                            >
                                <path d="M6 9l6 6 6-6" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServiceDetailsCard;
